"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(str) {
  str = str.replace(/[^\w\d]+/g, '_').replace(/^_/, '').replace(/_$/, '');
  return str || '_';
};